import styled from 'styled-components';

import { theme } from '../../../../../common/ui/theme';

export const OfferSupplierAndTotalsGrid = styled.div`
    display: grid;
    grid-template-columns: 40px 1fr auto;
    grid-template-rows: 40px;
    border-bottom-width: 1px;
    border-bottom-style: solid;
    border-bottom-color: ${theme.colors.border.muted};
    padding-bottom: ${theme.space[8]};
    gap: ${theme.space[16]};
`;
